import React from "react";
import {useStores} from "../../stores";
import {Navigate, useLocation} from "react-router";
import {locationToURL} from "../../routing/routing.utils";
import type {LoginRouteState} from "./LoginRouteState";
import {routes} from "../../routing/routes";


export type Props = {
    children?: React.ReactNode
}

/**
 * https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f
 */
export const RequireAuth: React.FC<Props> = ({children}) => {
    const {authStore} = useStores();
    const location = useLocation();
    const loggedIn = authStore.isLoggedIn();

    if (!loggedIn) {
        const loginUrl = routes.login;
        const loginState: LoginRouteState = {
            state: 'LoginRouteState',
            loginIntention: {
                autoLogin: location.pathname !== loginUrl,
                onSuccessRedirectTo: locationToURL(location),
                onSuccessRedirectOptions: {
                    state: location.state,
                }
            }
        }
        console.log('RequireAuth: redirecting to login', loginUrl, loginState);
        return <Navigate to={loginUrl} replace state={loginState}/>;
    }
    return <>{children}</>;
}
